export default __webpack_public_path__ + "static/media/kitchen-cabinet.3299c034.jpg";